import * as d3 from 'd3'

export default {
  methods: {

    link_Action() {
      
      // this.set_selectedItems()

      // Remove
      this.canvasChart.remove()
      this.canvasSummary.remove()

      // Initial Data
      d3.select(`#TITLE_${this.localId}`).text(this.menus.list.find(f=> f.code == this.current.menu).name)
      this.init_ChartData()
  
      // Drawing
      this.draw_chartTimeline()
      this.chart_Controller()
      this.draw_Milestone()

    },



  }
}